import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { useAuthStore } from '@revelio/auth';

import { environment } from '../../environments/environment';

export const useDashMetaCsrf = () => {
  const setDashMetaCsrfToken = useAuthStore(
    (state) => state.setDashMetaCsrfToken
  );
  const { data, isLoading } = useQuery<string>({
    queryKey: ['dash-meta-csrf'],
    queryFn: fetchDashMetaCsrf,
  });

  useEffect(() => {
    if (data && !isLoading) {
      setDashMetaCsrfToken(data);
    }
  }, [data, isLoading, setDashMetaCsrfToken]);

  return { data, isLoading };
};

type CsrfResponse = {
  csrfToken: string;
};
const fetchDashMetaCsrf = async (): Promise<string> => {
  try {
    const response = await fetch(`${environment.DASH_META_API}/surf`, {
      headers: { 'request-id': crypto.randomUUID() },
      credentials: 'include',
    });

    if (!response.ok) throw await response.json();

    const { csrfToken }: CsrfResponse = await response.json();
    return csrfToken;
  } catch (err) {
    console.error('FETCH_DASH_META_CSRF', err);
    return 'missing';
  }
};
